const reviews = [
  {
    quote:
      "Amber turned my lounge into a spa. My skin hasn't looked this calm and glowing in years — I genuinely look forward to every appointment.",
    name: "Hannah",
    location: "Mt Eden, Auckland",
  },
  {
    quote:
      "Professional, gentle and incredibly knowledgeable. The LED + facial combo is the closest thing to a real reset I've ever had.",
    name: "Sienna",
    location: "Ponsonby, Auckland",
  },
  {
    quote:
      "Microneedling with Amber softened scarring I'd given up on. She explains everything, and the at-home convenience is just unmatched.",
    name: "Priya",
    location: "Remuera, Auckland",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative bg-[#F9F5F0] py-24 md:py-36"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-20">
        <div className="flex items-center gap-4 mb-12">
          <span className="h-px w-8 bg-[#B78782]" />
          <span className="text-[11px] tracking-[0.4em] uppercase text-[#B78782]">
            Kind Words
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-16">
          {reviews.map((r, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className={`relative ${
                i === 1 ? "lg:translate-y-12" : i === 2 ? "lg:translate-y-6" : ""
              }`}
            >
              <span className="font-serif-display text-[#B78782]/40 text-7xl leading-none select-none">
                &ldquo;
              </span>
              <blockquote className="font-serif-display text-[#4A3737] text-2xl md:text-[28px] font-light leading-snug -mt-6">
                {r.quote}
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-[#B78782]/30">
                <p className="text-sm text-[#4A3737] font-medium">{r.name}</p>
                <p className="text-[11px] tracking-[0.24em] uppercase text-[#4A3737]/60 mt-1">
                  {r.location}
                </p>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
